import { useEffect } from "react";
import { toast } from "sonner";
import { checkBackendHealth } from "@/hooks/useHealthCheck";
import { getConnectionError, ConnectionError } from "@/constants";
import { useTranslation } from "react-i18next";

/**
 * Check backend health on mount and show error toast if backend is unavailable.
 * Single responsibility: Monitor backend availability and notify user of failures.
 * Uses VITE_BACKEND_URL for direct backend access.
 */
export function useBackendHealthCheck(): void {
  const { t } = useTranslation("errors");

  useEffect(() => {
    checkBackendHealth().then((ok) => {
      if (!ok) {
        const backendUrl = import.meta.env.VITE_BACKEND_URL || "(not configured)";
        toast.error(getConnectionError(ConnectionError.BACKEND_FAILED), {
          description: t("backend.connectionFailed", { apiUrl: backendUrl }),
          duration: 10000,
          richColors: true,
          closeButton: true,
        });
      }
    });
  }, [t]);
}
